/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { NumberTagDefinitionWithLinks } from '../models/number-tag-definition-with-links';
@Injectable({
  providedIn: 'root',
})
class NumberDefinitionsWithLinksService extends __BaseService {
  static readonly NumberDefinitionsWithLinksGetPath = '/number-definitions-with-links/{tagDefinitionId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns the number tag definition with links
   * @param params The `NumberDefinitionsWithLinksService.NumberDefinitionsWithLinksGetParams` containing the following parameters:
   *
   * - `tagDefinitionId`: GUID of the tag definition
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  NumberDefinitionsWithLinksGetResponse(params: NumberDefinitionsWithLinksService.NumberDefinitionsWithLinksGetParams): __Observable<__StrictHttpResponse<NumberTagDefinitionWithLinks>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/number-definitions-with-links/${encodeURIComponent(String(params.tagDefinitionId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<NumberTagDefinitionWithLinks>;
      })
    );
  }
  /**
   * Returns the number tag definition with links
   * @param params The `NumberDefinitionsWithLinksService.NumberDefinitionsWithLinksGetParams` containing the following parameters:
   *
   * - `tagDefinitionId`: GUID of the tag definition
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  NumberDefinitionsWithLinksGet(params: NumberDefinitionsWithLinksService.NumberDefinitionsWithLinksGetParams): __Observable<NumberTagDefinitionWithLinks> {
    return this.NumberDefinitionsWithLinksGetResponse(params).pipe(
      __map(_r => _r.body as NumberTagDefinitionWithLinks)
    );
  }
}

namespace NumberDefinitionsWithLinksService {

  /**
   * Parameters for NumberDefinitionsWithLinksGet
   */
  export interface NumberDefinitionsWithLinksGetParams {

    /**
     * GUID of the tag definition
     */
    tagDefinitionId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }
}

export { NumberDefinitionsWithLinksService }